module.exports = __webpack_public_path__ + "static/media/60461685_1887590578011433_721032989324083200_o.21444078.png";